import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './pages/Home';
import ServiceReleaseDetailsPage from './pages/ServiceReleaseDetailsPage';

import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import { InMemoryCache } from 'apollo-cache-inmemory';

const defaultOptions = {
  query: {
    fetchPolicy: 'cache-first',
  },
};

const client = new ApolloClient({
  uri: 'https://chronicle.k8s.sendgrid.net/graphql',
  cache: new InMemoryCache(),
  defaultOptions,
} as any);

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/services/:service_name" component={ServiceReleaseDetailsPage} />
          <Route component={Home} />
        </Switch>
      </Router>
    </ApolloProvider>
  );
}

export default App;